export default (obj1 = {}, obj2 = {}) => {
  if (!obj1 || !obj2) return false;

  return obj1.id.toString() === obj2.id.toString();
};
